import React from 'react';
import './Home.css';
import Gallary1 from '../Gallary/Gallary1/Gallary1';
import HeroPart from './HeroPart/HeroPart';
import Services from '../Services/Services';
import Offers from './Offers/Offers';
import Destinations from './Destinations/Destinations';
import Gallary from '../Gallary/Gallary';
const Home = () => {
    return (
        <div>
            <HeroPart></HeroPart>
            <Services></Services>
            <Gallary></Gallary>
            <Destinations></Destinations>
            <Offers></Offers>
            <Gallary1></Gallary1>
        </div >
    );
};

export default Home;